import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  hasCookieConsentAnswer,
  saveCookieConsent,
  hasCookieConsent,
} from "../utils/pdConsent";
import { loadConsentedAnalytics } from "../utils/loadAnalyticsAfterConsent";
import "./CookieConsentBanner.css";

// Название счётчика — только в основной сборке: у сайта «только проверки» он свой
const ANALYTICS_SERVICE_NOTE = process.env.REACT_APP_EDITION === "checks" ? "" : " (Top.Mail.Ru)";
const ANALYTICS_DETAIL =
  process.env.REACT_APP_EDITION === "checks"
    ? "Обезличенная статистика посещений"
    : "Top.Mail.Ru — обезличенная статистика посещений";

const CookieConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!hasCookieConsentAnswer()) {
      setVisible(true);
    } else if (hasCookieConsent()) {
      loadConsentedAnalytics();
    }
  }, []);

  const handleAccept = () => {
    saveCookieConsent(true);
    loadConsentedAnalytics();
    setVisible(false);
  };

  const handleDecline = () => {
    saveCookieConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Согласие на использование cookie">
      <div className="cookie-banner__inner">
        <div className="cookie-banner__body">
          <div className="cookie-banner__icon">🍪</div>
          <div className="cookie-banner__text">
            <p className="cookie-banner__title">Мы используем cookie-файлы</p>
            <p className="cookie-banner__desc">
              Сервис использует <strong>технические cookie</strong> для авторизации и работы сессий,
              а также <strong>аналитические cookie</strong>{ANALYTICS_SERVICE_NOTE} для анализа посещаемости.
              Аналитические cookie загружаются только с вашего согласия.{" "}
              <Link to="/privacy#cookies" className="cookie-banner__link">
                Подробнее
              </Link>
            </p>
            {expanded && (
              <div className="cookie-banner__details">
                <div className="cookie-banner__detail-row">
                  <span className="cookie-banner__detail-type">Технические</span>
                  <span className="cookie-banner__detail-desc">
                    Авторизация, CSRF-защита, сессия — необходимы для работы сервиса
                  </span>
                  <span className="cookie-banner__detail-badge cookie-banner__detail-badge--required">
                    Обязательные
                  </span>
                </div>
                <div className="cookie-banner__detail-row">
                  <span className="cookie-banner__detail-type">Аналитические</span>
                  <span className="cookie-banner__detail-desc">
                    {ANALYTICS_DETAIL}
                  </span>
                  <span className="cookie-banner__detail-badge cookie-banner__detail-badge--optional">
                    С согласия
                  </span>
                </div>
              </div>
            )}
            <button
              type="button"
              className="cookie-banner__toggle"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? "Скрыть подробности" : "Подробнее о cookie"}
            </button>
          </div>
        </div>
        <div className="cookie-banner__actions">
          <button
            type="button"
            className="cookie-banner__btn cookie-banner__btn--accept"
            onClick={handleAccept}
          >
            Принять все
          </button>
          <button
            type="button"
            className="cookie-banner__btn cookie-banner__btn--decline"
            onClick={handleDecline}
          >
            Только необходимые
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
